import React from "react";
import VehicleArt from "../components/VehicleArt.jsx";
import SectionHead from "../components/SectionHead.jsx";
import CtaBand from "../components/CtaBand.jsx";
import Icon from "../components/icons/Icon.jsx";
import Check from "../components/icons/Check.jsx";
import FLEET, { FUTURE_FLEET } from "../data/fleet.js";

const Fleet = ({ go }) => (
  <div className="page">
    <section className="phero">
      <div className="wrap">
        <span className="eyebrow">Our fleet</span>
        <h1 className="h-xl" style={{ maxWidth: "16ch" }}>Built for every kind of load</h1>
        <p className="lead" style={{ marginTop: 24 }}>From electric vans working inside clean air zones to
          44 tonne articulated units running the length of the country — all owned, maintained and driven by us.</p>
      </div>
    </section>

    <section className="sec-tight">
      <div className="wrap">
        {FLEET.map((v, idx) => (
          <div className={"fleet-row reveal" + (idx % 2 ? " rev" : "")} key={v.key}
               style={idx === 0 ? { borderTop: 0 } : undefined}>
            <div className="fleet-art"><VehicleArt type={v.key} label={v.name} /></div>
            <div>
              <span className="eyebrow">{v.specs[0][1]}</span>
              <h2 className="h-md" style={{ fontSize: "clamp(1.6rem,3vw,2.2rem)" }}>{v.name}</h2>
              <p className="lead" style={{ marginTop: 16, fontSize: "1rem" }}>{v.desc}</p>
              <div className="two-col">
                <div>
                  <div className="col-h">Transport capabilities</div>
                  {v.capabilities.map((c) => <div className="ck" key={c}><Check /><span>{c}</span></div>)}
                </div>
                <div>
                  <div className="col-h">Advantages</div>
                  {v.advantages.map((c) => <div className="ck" key={c}><Check /><span>{c}</span></div>)}
                </div>
              </div>
              <div className="spec" style={{ marginTop: 26 }}>
                {v.specs.map(([k, val]) => (
                  <div key={k}><span className="st">{k}</span><span className="sv">{val}</span></div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>

    <section className="sec mist">
      <div className="wrap">
        <SectionHead eyebrow="Future fleet expansion" title="What comes next"
          lead="Fleet investment is planned around two things: the work our customers are asking for, and the emissions standards coming for the areas we deliver into." />
        <div className="grid g3">
          {FUTURE_FLEET.map((f) => (
            <article className="card reveal" key={f.t}>
              <div className="ico"><Icon name={f.i} /></div>
              <h3>{f.t}</h3><p>{f.d}</p>
            </article>
          ))}
        </div>
      </div>
    </section>

    <CtaBand go={go} />
  </div>
);

export default Fleet;
